import React from 'react';

export const noInfosLabel = (message: string) => (
  <span style={{ fontStyle: 'italic' }}>{message}</span>
);
